import { useProductStoreContext } from "@project/emerge";
import { Edges } from "@react-three/drei";

export const PartEdges = () => {
  const useProductStore = useProductStoreContext();
  const showEdges = useProductStore((state) => state.showEdges);
  if (!showEdges) return null;
  return <Edges color="black" />;
};
